export const chaveRecaptcha = process.env.REACT_APP_CAPTCHA_KEY;